import React, { useEffect } from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrder } from '../context';
import { ActionButtons } from '../components/OrderDetail/ActionButtons';
import { OrderInfo } from '../components/OrderDetail/OrderInfo';
import { ModalDelete } from '../components/ModalDelete';
import { Can } from '../../../shared/components/Permission';
import { ROLES } from '../../../shared/constants/roles';

export default function OrderDetailPage() {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    orderData,
    isDataLoading,
    setOrderId,
    navigateToEdit,
    openDeleteModal,
    closeDeleteModal,
    isDeleteModalOpen,
    handleDeleteOrder,
    isDeleting,
  } = useOrder();

  useEffect(() => {
    if (id) setOrderId(id);
  }, [id, setOrderId]);

  if (isDataLoading) return <div>Carregando...</div>;
  if (!orderData) return <div>Encomenda não encontrada</div>;

  const isDelivered = orderData.status === 'DELIVERED';

  return (
    <Box sx={{ p: { xs: 1, md: 3 }, width: '100%', maxWidth: '100%', margin: '0 auto' }}>
      <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: 4, boxShadow: '0 2px 12px 0 rgba(16,30,54,0.06)', width: '100%' }}>
        <Typography fontWeight={700} fontSize={18} color={theme.palette.text.primary} mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalShippingIcon sx={{ color: theme.palette.primary.main, fontSize: 22 }} /> Detalhes da Encomenda
        </Typography>
        <Can roles={[ROLES.ADMIN, ROLES.GESTOR]}>
          <ActionButtons
            onEdit={() => navigateToEdit(orderData.id)}
            onDelete={() => openDeleteModal(orderData)}
            isDeleting={isDeleting}
            orderId={orderData.id}
            onDeliver={() => navigate(`/orders/${orderData.id}/deliver`)}
            isDelivered={orderData.status === 'DELIVERED'}
          />
        </Can>

        <OrderInfo
          orderId={orderData.id}
          orderNumber={orderData.orderCode}
          createdAt={orderData.receivedAt}
          origin={orderData.origin}
          recipientName={orderData.recipientName}
          receivedBy={orderData.receivedBy}
          deliveredBy={orderData.deliveredBy}
          deliveredAt={orderData.deliveredAt}
          deliveryDocument={orderData.deliveryDocument}
          status={orderData.status}
          userName={orderData.user?.name}
          pickupToken={orderData.pickupToken}
          pickupPin={orderData.pickupPin}
        />
      </Paper>
      <ModalDelete
        open={isDeleteModalOpen}
        onClose={closeDeleteModal}
        onConfirm={handleDeleteOrder}
        loading={isDeleting}
        orderName={orderData.orderCode}
      />
    </Box>
  );
}